export const ZEND_CHAT_HEIGHT_IN_PX = 130;
